<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> Annual Maintenance Contract </h3>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createAmc">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" data-bs-toggle="modal" data-bs-target="#deleteAmc" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createAmc" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: calc(100vh - 120px) !important;" 
                         class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>


<!-- Create new Lead -->
<div class="modal fade bd-example-modal-lg" id="createAmc" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="amcForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create Annual Contract</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <!-- <div class="input">
                                <div class="input-item">
                                    <input formControlName="id" type="text" required>
                                    <label for="id" class="floating-label">ID</label>
                                    <i class="ri-shield-user-line"></i>
                                </div>
                            </div> -->
                            <div class="input">
                                <div class="input-item">
                                    <!-- <input formControlName="supplierName" type="text" required>
                                    <label for="supplierName" class="floating-label">Supplier Name</label> -->
                                    <label class="floating-label floating-label-special"></label>
                                    <input
                                        list="taskOwnerDatalist"
                                        formControlName="supplierName"
                                        placeholder="Supplier Name"
                                    />
                                    <datalist id="taskOwnerDatalist">
                                        <option
                                        [value]="item"
                                        *ngFor="let item of userDropdownList"
                                        ></option>
                                    </datalist>
                                    <i class="ri-building-line"></i>
                                </div>
                                <mat-error *ngIf="f.supplierName.invalid && (f.supplierName.dirty ||f.supplierName.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.supplierName.errors.required">
                                       supplierName is required
                                    </mat-error>
                                  </mat-error>    
                            </div>
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contractPeriod" type="text">
                                    <label for="contractPeriod" class="floating-label">Contract Period</label>
                                    <i class="ri-time-line"></i>
                                </div>
                            </div>
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="servicesProvidedBySupplier" type="text" >
                                    <label for="servicesProvidedBySupplier" class="floating-label">services Provided By Supplier</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">                            
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="activityDescription" type="text" >
                                    <label for="activityDescription" class="floating-label">Activity Description</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="servicesBySupplier" type="text" >
                                    <label for="servicesBySupplier" class="floating-label">Services By Supplier</label>
                                    <i class="ri-file-list-line"></i>
                                </div>
                            </div>
                        
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="aggrementReference" type="text" >
                                    <label for="aggrementReference "class="floating-label">Aggrement Reference</label>
                                    <i class="ri-mail-unread-line"></i>
                                </div>
                            </div>
                            
                        </div>
                        <!-- <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contractPeriod" type="text" required>
                                    <label for="contractPeriod" class="floating-label">Contract Period</label>
                                    <i class="ri-phone-line"></i>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contractStartDate" type="date" required>
                                    <label for="contractStartDate" class="floating-label">contract StartDate</label>
                                    <i class="ri-calendar-check-line"></i>
                                </div>
                                <mat-error *ngIf="f.contractStartDate.invalid && (f.contractStartDate.dirty || f.contractStartDate.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.contractStartDate.errors.required">
                                       contractStartDate is required
                                    </mat-error>
                                  </mat-error>    
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contractEndDate" type="date" required>
                                    <label for="contractEndDate" class="floating-label">contract EndDate</label>
                                    <i class="ri-calendar-check-line"></i>
                                </div>
                                <mat-error *ngIf="f.contractEndDate.invalid && (f.contractEndDate.dirty ||f.contractEndDate.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.contractEndDate.errors.required">
                                       contractEndDate is required
                                    </mat-error>
                                  </mat-error>    
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contractGracePeriod" type="text" >
                                    <label for="contractGracePeriod" class="floating-label">Contract Grace Period</label>
                                    <i class="ri-time-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="slaAgreedByServiceProvider" type="text" >
                                    <label for="slaAgreedByServiceProvider" class="floating-label">slaAgreed By ServiceProvider</label>
                                    <i class="ri-line-chart-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="frequencyOfReview" type="text" >
                                    <label for="frequencyOfReview" class="floating-label">Frequency Of Review</label>
                                    <i class="ri-24-hours-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="paymentTermsAndConditions" type="text">
                                    <label for="paymentTermsAndConditions" class="floating-label">payment Terms And Conditions</label>
                                    <i class="ri-building-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="accountManagerFromCompany" type="text" >
                                    <label for="accountManagerFromCompany" class="floating-label">Account Manager From Company</label>
                                    <i class="ri-building-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="accountManagerFromServiceProvider" type="text" >
                                    <label for="accountManagerFromServiceProvider" class="floating-label">Account Manager Provider</label>
                                    <i class="ri-money-dollar-circle-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="serviceSubcontracted">
                                        <option [ngValue]="true">True</option>
                                        <option [ngValue]="false">False</option>
                                        </select>
                                        <label  class="floating-label floating-label-special">Select Service Subcontracted</label>
                                    <i class="ri-star-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="subcontractDetails" type="text" >
                                    <label for="subcontractDetails" class="floating-label">Subcontract Details</label>
                                    <i class="ri-skype-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="relationWithSubcontractor" type="text" >
                                    <label for="relationWithSubcontractor" class="floating-label">Relation With Subcontractor</label>
                                    <i class="ri-twitter-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="remark" type="text" >
                                    <label for="remark" class="floating-label">Remark</label>
                                    <i class="ri-mail-unread-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createAMC()" [disabled]="!amcForm.valid ? true:null" >Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateamc()" >Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteAmc" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteLead" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteAmcList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 
